module.exports = __webpack_public_path__ + "static/media/ic-countermovement-jump.04bdfbb7.svg";